module.exports = __webpack_public_path__ + "img/gold-spark.848f8296.gif";